import { _ } from "../../core/polyglot/polyglot.js";
import { companyIcon } from "../../core/elements/icons/icons.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import ArrayStream from "../../core/list/streams/ArrayStream.js";
import CardWidget from "../../core/widgets/CardWidget/CardWidget.js";
import Company from "../../models/Company.js";
import EmptyArchiveWidget from "../../core/widgets/emptyArchive/EmptyArchiveWidget.js";
import externalDocument from "../shared/externalDocument.js";
import ListSource from "../../core/list/ListSource.js";
import makeCardListWidget from "../../core/widgets/list/CardListWidget/makeCardListWidget.js";
import session from "../../core/session.js";

/**
 * `listCompaniesDocument' renders a list of companies for a
 * company user. When only one company is attached to the user, it
 * is redirected directly to the company presentation view.
 */
function listCompaniesDocument(spec, my) {
	spec ||= {};
	my ||= {};
	const that = externalDocument(spec, my);

	that.showHeader = true;
	that.documentId = "no-leftmenu admin-body my-companies-body";
	that.pageTitle = _("My Companies");
	that.title = _("My Companies");

	const user = session.getCurrentUser();

	my.companiesRepository = makeMonitorRepository({
		route: "/Shared/MyCompanies",
		model: Company,
		antiForgeryToken: session.getAntiForgeryToken(),
	});

	that.headerButtons = function (html) {
		html.div({
			class: "img-circle pull-right header-icon fp-logout",
		}).click(() => {
			my.redirectToLocationPath("/External/Authenticate/Logout");
		});

		if (user.isConsultant()) {
			html.div({
				class: "img-circle pull-right header-icon fp-add",
			}).click(() => {
				my.redirectTo("import", {});
			});
		}
	};

	that.listCompanies = function () {
		my.companiesRepository.get().then((companies) => {
			my.listCompanies(companies);
		});
	};

	my.cardList = makeCardListWidget({
		itemRenderer: (company) => my.companyRenderer(company),
	});

	my.renderContentOn = function (html) {
		html.div(my.cardList);
	};

	my.renderEmptyContentOn = function (html) {
		html.render(
			new EmptyArchiveWidget({
				title: _("Your user is not connected to any company"),
				subtitle: _(
					"Please contact your accounting consultant to get access to the company you want to analyze.",
				),
			}),
		);
	};

	my.companyRenderer = function (company) {
		return new CardWidget({
			title: (html) =>
				html.span({ title: company.getName() }, company.getName()),
			subtitle: company.getBusinessIdentityCode(),
			roundedIcon: true,
			icon: companyIcon,
			href: my.linkTo("loadCompany", { id: company.getLegacyId() }),
			footer: (html) =>
				html.span(
					{ class: "btn btn-admin btn-block" },
					html.span(
						{ class: "fp-go-to-presentation" },
						_("Go to Presentation"),
					),
				),
		});
	};

	my.listCompanies = function (companies) {
		if (!companies.length) {
			that.showEmpty();
			return;
		}

		my.cardList.setSource(
			ListSource.makeAndFetch({
				stream: new ArrayStream({ data: companies }),
			}),
		);

		that.showContent();
	};

	my.setLocation = function (url) {
		my.redirectToLocationPath(url);
	};

	return that;
}

export default listCompaniesDocument;
